export const IconStars20: {
  name: 'icon_stars_20-deb00fb0bc3c'
} = {
  name: 'icon_stars_20-deb00fb0bc3c'
}
